import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import moment from 'moment-jalaali';

// distinct storage key so lead-data filters never collide with the ticket 'filters' key
const LEAD_DATA_FILTERS_KEY = 'leadDataFilters';

const getLeadDataStoredFilters = (): any => {
  try {
    return JSON.parse(sessionStorage.getItem(LEAD_DATA_FILTERS_KEY) || '{}') || {};
  } catch {
    return {};
  }
};

const buildLeadDataSubmittedFiltersFromStorage = () => {
  const f = getLeadDataStoredFilters();
  return {
    member: f.member || "",
    from_date: f.from_date || null,
    to_date: f.to_date || null,
    state: f.state || "",
  };
};

const initialLeadDataFilters = getLeadDataStoredFilters();

interface IProps {

}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  openModal: boolean;
  openEditModal: boolean;
  loading: boolean;
  leadsDataList?: any;
  page: number;
  state: string;
  statesList: any;
  count:number;
  member:any;
  selectedItem:any;
  membersList:any[];
  errorsList:any;
  openShowMoreModal:boolean;
  details:any;
  step:number;
  openAddModal:boolean;
  addInfo:any;
  newInfo:any;
  from_date: any;
  to_date:any;
  rowsCountList:any;
  submittedFilters: any;

}

export class LeadDataController extends Component<IProps, IState> {
  datePickerRef: any;
  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }
  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    openModal: false,
    openEditModal: false,
    loading: false,
    leadsDataList: [],
    page: 1,
    state: initialLeadDataFilters.state || "",
    statesList: [],
    count:6,
    member: initialLeadDataFilters.member || "",
    membersList:[],
    selectedItem:null,
    errorsList:[],
    openShowMoreModal: false,
    details:{},
    step:0,
    openAddModal:false,
    addInfo:{},
    newInfo:null,
    from_date: initialLeadDataFilters.from_date || null,
    to_date: initialLeadDataFilters.to_date || null,
    rowsCountList:[6, 10, 50, 100],
    submittedFilters: buildLeadDataSubmittedFiltersFromStorage(),

  };
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page:1 });
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getLeadsDataList()
    }, 800);
  }
  id: any = this.state.open ? 'simple-popper' : undefined;

  search = async (e: any) => {
    this.setState({ str: e })
  };
  handleChange = (e: any) => {
    this.setState({ state: e.target.value })
  };

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
  };
  getLeadsDataList = async () => {
    this.setState({ loading: true })
    const { page, count, state, member, from_date, to_date } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count : null,
      user_id: member ? member : null,
      state_id: state ? state : null,
      from_date: from_date ? from_date : null,
      to_date: to_date ? to_date : null,
    }
    let url = new URL(`${AppConstants.base_url_api}lead/${window.location.pathname.split("/")[2]}/data`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.append(key, value)
      }
    }
    try {
      const response = await service.Leads.leadDataList(url.search);
      if (response) {
        if(response.status === 200){
          this.setState({ leadsDataList: response?.data?.data, openModal: false, loading:false });
        }
        else{
          toast.error(response.data.message);
        }
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      // throw error;
    }
  };
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getLeadsDataList()
    }, 800);
  }

  handleOpenModal = () =>{
    const { openModal }  = this.state;
    this.setState({ openModal: !openModal });
    this.getMembersList();
    this.getStatesList();
  }
  getMembersList = async () => {
    try {
      const response = await service.LeadsMember.list();
      if (response) {
        if(response.status === 200){
          this.setState({ membersList: response?.data?.data?.list })
        }
        else{
          toast.error("مشکلی پیش آمده‌است")
        }
      } else {
        toast.error("مشکلی پیش آمده‌است")
      }
    } catch (error) {
    }
  };
  getStatesList = async () => {
    try {
      const response = await service.Leads.states();
      if (response) {
        this.setState({ statesList: response?.data?.data?.list, loading: false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
    }
  };
  handleChangeState = (item:any) =>{
    this.setState({openEditModal: true, selectedItem:item});
    this.getStatesList();
  }
  async changeState (){
    const { state, selectedItem } = this.state;
    const schema = yup.object({
      state: yup.string().required(" وضعیت اجباری می‌باشد"),
      });   
      try {
        await schema.validate({ state }, { abortEarly: false });
        const response = await service.Leads.updateState(selectedItem?.id, parseInt(state));
          if (response) {
              if(response?.status === 200){
                  this.setState({ errorsList:[], openEditModal: false, state:"" });
                  this.getLeadsDataList();
                  toast.success(response.data.message);
              }
              else{
                  toast.error(response.data.message);
                  this.setState({ errorsList:[], openEditModal: false, state:"" });
              }
          } else {
              this.setState({ loading:false, errorsList:[], openEditModal: false, state:"" });
              toast.error("مشکلی پیش آمده‌است");

          }  
      } catch (err: any) {
        this.setState({ errorsList: err.inner  })
      } 
  }

  async handleShowMore (item:any) {
    try {
      const response = await service.Leads.getDetails(item?.id);
      if (response) {
        this.setState({ details: response?.data });
        this.setState({selectedItem: item, openShowMoreModal: true});

      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
    }
  
}
handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
  this.setState({step:newValue});
};
async handleOpenAdd() {
  try {
    const response = await service.Leads.LeadList();
    if (response) {
      this.setState({ addInfo: response?.data?.data,openAddModal: true });
    } else {
      this.setState({ loading: false })
    }
  } catch (error) {
  }

}
handleAddModalInputsChange = (key: string, value: string) => {
  const { addInfo, newInfo } = this.state;
    addInfo[key].value = value;
    this.setState({
      addInfo,
      newInfo: { ...newInfo, [key]: value },
    });
  }
  handleAddLead = async() =>{
    const { newInfo } = this.state;
        try {
          const response = await service.Leads.Add(newInfo);
      if (response) {
        if(response.status === 200){
          toast.success(response.data.message);
          this.setState({openAddModal: false, addInfo:{}, newInfo:null});
          this.getLeadsDataList();
        }
        else{
          toast.error("مشکلی پیش آمده‌است")
        }
      } else {
        toast.error("مشکلی پیش آمده‌است")
      }
    } catch (error:any) {
      toast.error(error?.data?.message);  
    }
    
  }
  emptyFromDate= () => {
    this.setState({ from_date: "", page:1 });
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, from_date: "", page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  emptyToDate= () => {
    this.setState({ to_date: "", page:1 });
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, to_date: "", page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  handleChangeFromDate = (value: any) => {
    this.setState({ from_date:value ? fixNumbers(value.format()) : null, page:1 })
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, from_date: value ? fixNumbers(value.format()) : null, page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  handleChangeToDate = (value: any) => {
    this.setState({ to_date:value ? fixNumbers(value.format()) : null, page:1 });
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, to_date: value ? fixNumbers(value.format()) : null, page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  handleMemberChange = (e: any) => {
    this.setState({ member: e.target.value, page:1 });
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, member: e.target.value, page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  handleStateFilterChange = (e: any) => {
    this.setState({ state: e.target.value, page:1 });
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, state: e.target.value, page:1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  closeModal = () => {
    this.setState({ openModal: false });
  };
  handleApplyFilter = () => {
    const { member, from_date, to_date, state } = this.state;
    this.setState({
      page: 1,
      submittedFilters: { member, from_date, to_date, state },
      openModal: false,
    }, this.getLeadsDataList);
    const filters = getLeadDataStoredFilters();
    const updatedFilter = { ...filters, member, from_date, to_date, state, page: 1 };
    sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
  };
  hasActiveFilter = () => {
    const sf = this.state.submittedFilters;
    if (!sf) return false;
    return !!(sf.member || sf.from_date || sf.to_date || sf.state);
  };
  getActiveFiltersList = () => {
    const { submittedFilters, membersList, statesList } = this.state;
    const sf = submittedFilters || {};
    const items: { label: string; value: string; onRemove: () => void }[] = [];

    const memberTitle = membersList?.find(
      (m: any) => String(m?.id) === String(sf.member)
    )?.title;
    const stateTitle = statesList?.find(
      (s: any) => String(s?.id) === String(sf.state)
    )?.title;

    const removeFilter = (key: string, stateKey?: string) => {
      const newSf = { ...sf, [key]: null };
      const newState: any = { submittedFilters: newSf };
      if (stateKey) {
        newState[stateKey] = "";
      }
      const filters = getLeadDataStoredFilters();
      const updatedFilter = { ...filters, [key]: "" };
      sessionStorage.setItem(LEAD_DATA_FILTERS_KEY, JSON.stringify(updatedFilter));
      this.setState(newState, this.getLeadsDataList);
    };

    if (sf.member) {
      items.push({ label: "اعضا", value: memberTitle || sf.member, onRemove: () => removeFilter("member", "member") });
    }
    if (sf.from_date) {
      items.push({ label: "از تاریخ", value: sf.from_date, onRemove: () => removeFilter("from_date", "from_date") });
    }
    if (sf.to_date) {
      items.push({ label: "تا تاریخ", value: sf.to_date, onRemove: () => removeFilter("to_date", "to_date") });
    }
    if (sf.state) {
      items.push({ label: "وضعیت", value: stateTitle || sf.state, onRemove: () => removeFilter("state", "state") });
    }

    return items;
  };
}
export default LeadDataController;